import styled from 'styled-components';
import { device } from '../../styles/devices';

interface StyleProps {
  margin?: boolean;
}

export const Wrapper = styled.div`
  padding: 0 18px;
  padding-top: 48px;
  @media ${device.tablet} {
    padding: 48px 32px 60px;
  }
  @media ${device.laptopL} {
    display: flex;
    flex-direction: row;
    padding: 48px 0px 40px 60px;
    margin: 0 auto;
  }
`;

export const Colours = styled.div`
  flex: 1 1 270px;
`;

export const TitleWrap = styled.div`
  display: flex;
`;

export const IconWrap = styled.div`
  margin-right: 18px;
  @media ${device.laptopL} {
    margin-right: 20px;
  }
`;

export const ViewTechSpecsIconWrapper = styled.div`
  margin-right: 8px;
`;

export const Copy = styled.p`
  font-family: 'Audi Type';
  font-size: 13px;
  line-height: 17px;
`;

export const ExternalColour = styled.div`
  border-radius: 50px;
  max-width: 100%;
  min-width: 200px;
  height: 80px;
  margin-bottom: 12px;
`;

export const InternalColour = styled.div`
  border-radius: 50px;
  width: 129px;
  height: 80px;
  margin-bottom: 12px;
`;

export const ColourSwatch = styled.img`
  width: 100%;
  max-width: 100%;
  border-radius: 50px;
  height: 100%;
`;

export const Aspect = styled.div`
  display: flex;
  @media ${device.laptopL} {
    margin-bottom: 40px;
  }
`;

export const Body = styled.div`
  margin-bottom: 5%;
  @media ${device.laptopL} {
    flex: 1 1 775px;
    margin: 0 16px;
    ${Aspect} {
      margin-bottom: 0;
    }
  }
`;

export const BodyImageWrap = styled.div`
  height: 250px;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  @media ${device.tablet} {
    height: 300px;
  }
  @media ${device.laptop} {
    height: 385px;
  }
  @media ${device.laptopL} {
    height: 250px;
  }
`;

export const BodyImage = styled.img`
  width: 100%;
  max-width: 100%;
  height: 100%;
  object-fit: cover;
  @media ${device.tablet} {
    max-width: 824px;
  }
  @media ${device.laptopL} {
    max-width: 100%;
  }
`;

export const TextWrap = styled.div``;

export const Mechanics = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 32px;
  @media ${device.tablet} {
    align-items: flex-start;
  }
  @media ${device.laptop} {
    align-items: baseline;
  }
  ${Aspect} {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    @media ${device.tablet} {
      flex-direction: row;
      width: auto;
      align-items: flex-start;
    }
    @media ${device.laptop} {
      align-items: center;
      flex-direction: row;
    }
  }
  ${TextWrap} {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    @media ${device.tablet} {
      width: 100%;
    }
    @media ${device.laptop} {
      width: 80%;
      padding: 0;
      padding-right: 48px;
      margin-top: 0;
    }
    ${Copy} {
      width: 80%;
      margin: 0 auto;
      @media ${device.tablet} {
        width: 100%;
      }
      @media ${device.laptop} {
        width: 80%;
      }
    }
  }
  @media ${device.laptopL} {
    flex: 1 1 250px;
    display: block;
    margin-left: auto;
    ${Aspect} {
      flex-direction: row;
      width: 100%;
      justify-content: flex-start;
      align-items: flex-start;
      ${IconWrap} {
        margin: 0 18px 0 0;
      }
    }
    ${TextWrap} {
      width: 100%;
      text-align: left;
      ${Copy} {
        width: 100%;
      }
    }
  }
`;

export const LegalCopy = styled.p`
  width: 80%;
  margin: -10px auto 30px auto;
  display: block;
  font-family: 'Audi Type';
  font-size: 10px;
  line-height: 16px;
  text-align: center;
  color: #808080;
  @media (min-width: 500px) {
    margin: 0px auto 20px auto;
  }
  @media (min-width: 600px) {
    margin: 10px auto 0 auto;
  }

  @media ${device.tablet} {
    margin: 10px auto 0 auto;
  }
`;

export const ColourWrap = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 24px;
  margin-bottom: 42px;
  @media ${device.laptopL} {
    display: block;
    margin: 0;
  }
`;

export const External = styled.div`
  margin: ${({ margin }: StyleProps) => (margin ? '0 24px 0 0' : '0 15px 0 15px')};
  flex: 1 1 190px;
  max-width: 194px;
  @media ${device.tablet} {
    max-width: 225px;
  }
  @media ${device.laptopL} {
    margin: 15px 0;
  }
`;

export const Internal = styled.div`
  flex: 1 1 127px;
  @media ${device.laptopL} {
    margin: 15px 0;
  }
`;
